module.exports = __webpack_public_path__ + "img/HSBC.1f29eeca.png";